import * as React from 'react';

import { useIdentityContext } from './IdentityContext';
import { IdentityType } from './IdentityType';

interface IdentityGuardProps {
    children: React.ReactNode;
    targets: IdentityType[];
}

export const IdentityGuard = ({ children, targets }: IdentityGuardProps) => {
    const identity = useIdentityContext();

    return targets.includes(identity) ? <>{children}</> : <></>;
};
